import { PageController } from '@client/components/_core/layout/PageController';
import { PageLayoutHeader } from '@client/components/_core/layout/PageLayout/PageLayoutHeader';
import { SurfaceCard } from '@client/components/_ui/display/SurfaceCard';
import { EmptyState } from '@client/components/_ui/feedback/EmptyState';
import { createFileRoute } from '@tanstack/react-router';
import { BarChart3 } from 'lucide-react';

/**
 * A placeholder (CUR-1781) so fleet clients can see that reporting is on the way. It reads no
 * data and offers none of the console's reports or the assistant; the client reports and the
 * aggregate erosion view replace it later.
 */
export const Route = createFileRoute('/console/$orgId/fleet-portal/reporting')({
    staticData: {
        featureFlag: 'enable-fleet-portal-reporting',
        ui: {
            title: 'Reporting',
            subtitle: 'Claims and repair cost reports',
            icon: BarChart3,
        },
    },
    component: FleetPortalReportingPage,
});

function FleetPortalReportingPage() {
    return (
        <PageController route={Route}>
            <div>
                <PageLayoutHeader />
                <SurfaceCard>
                    <EmptyState
                        size="large"
                        icon={<BarChart3 />}
                        title="Reporting is coming soon"
                        description="We’re building reports on your claims and repair costs. They’ll appear here as soon as they’re ready."
                    />
                </SurfaceCard>
            </div>
        </PageController>
    );
}
